// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__20qcb","consentsList":"PatientConsents_consentsList__1JCOZ","consentsListEmpty":"PatientConsents_consentsListEmpty__2TScP"};